/**
 * Autosave triggers beyond the story-flag hook that GameContext installs itself.
 * ARCHITECTURE §6: "Autosave on every main flag and on scene enter". The integrator wires
 * `installAutosaveTriggers(ctx)` once from main.ts (see docs/core-change-requests/save-ui-builder.md).
 */
import { bus, Events } from '@/core/events';
import { SceneKeys } from '@/core/scenes/keys';
import type { GameContext } from '@/core/context';

const NO_AUTOSAVE_SCENES = new Set<string>([SceneKeys.BOOT, SceneKeys.PRELOAD, SceneKeys.TITLE, SceneKeys.UI, SceneKeys.SHOWCASE, SceneKeys.MEMORY_STAGE, SceneKeys.BATTLE]);

/** Returns a disposer. Safe to call once per game. */
export function installAutosaveTriggers(ctx: GameContext): () => void {
  const onEnter = (payload: { key: string }) => {
    if (NO_AUTOSAVE_SCENES.has(payload.key)) return;
    ctx.autosave();
  };
  bus.onTyped(Events.SCENE_ENTER, onEnter);
  return () => bus.offTyped(Events.SCENE_ENTER, onEnter);
}
